import React from 'react';

const IconChevronDown = () => {
    return (
        <svg className="icon-svg" style={{height: 24, width: 24}} preserveAspectRatio="xMidYMid meet" viewBox="0 0 100 100">
            <g>
                <polygon points="71.21 32.32 50 53.54 28.79 32.32 21.72 39.39 50 67.68 78.28 39.39 71.21 32.32" />
            </g>
        </svg>
    )
};

export default IconChevronDown;



// WEBPACK FOOTER //
// ./src/icons/icon-chevron-down.js